import { useState, useEffect } from 'react';
import { BREAKPOINTS_NUM } from '~/constants/breakpoints';

export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const handleChange = () => setMatches(mediaQuery.matches);

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [query]);

  return matches;
};

export const useBreakpoints = () => {
  const isPhone = useMediaQuery(`(max-width: ${BREAKPOINTS_NUM.phone - 1}px)`);
  const isPhoneOrLarger = useMediaQuery(`(min-width: ${BREAKPOINTS_NUM.phone}px)`);

  const isTabletMini = useMediaQuery(
    `(min-width: ${BREAKPOINTS_NUM.phone}px) and (max-width: ${BREAKPOINTS_NUM.tabletMini - 1}px)`,
  );
  const isTabletMiniOrLarger = useMediaQuery(`(min-width: ${BREAKPOINTS_NUM.tabletMini}px)`);

  const isTablet = useMediaQuery(
    `(min-width: ${BREAKPOINTS_NUM.tabletMini}px) and (max-width: ${BREAKPOINTS_NUM.tablet - 1}px)`,
  );
  const isTabletOrLarger = useMediaQuery(`(min-width: ${BREAKPOINTS_NUM.tablet}px)`);

  const isMobile = useMediaQuery(`(max-width: ${BREAKPOINTS_NUM.tabletMini - 1}px)`);

  const isDesktop = useMediaQuery(`(min-width: ${BREAKPOINTS_NUM.desktop}px)`);
  const isNotDesktop = useMediaQuery(`(max-width: ${BREAKPOINTS_NUM.desktop - 1}px)`);

  return {
    isPhone,
    isPhoneOrLarger,
    isTabletMini,
    isTabletMiniOrLarger,
    isTablet,
    isTabletOrLarger,
    isDesktop,
    isMobile,
    isNotDesktop,
    isMobileOrLarger: isPhoneOrLarger,
  };
};
